import contract from '@mailobj-browser/front/js/contracts/contract.js'
import array from '@mailobj-browser/front/js/utils/array.js'
import reset from './reset.js'

export default contract({
  reset: array([
    reset
  ])
})